import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { setConfiguration } from 'react-grid-system';
import AppContext from './contexts/index';
import AppNavigator from './navigation';

// The gutter width in pixels. A gutter width of 30 means 15px on each side of a column.
// By design we shall have 32 on each side of a column therefore gutterWidth:64
setConfiguration({ gutterWidth: 64 });

const App: FC = () => (
  <BrowserRouter>
    <AppContext>
      <AppNavigator />
    </AppContext>
  </BrowserRouter>
);

export default App;
